/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Modules_OwnershipInputs */

const cs_clients_modules_ownership = /** @type {(inputs: Clients_Modules_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnictví (prodávající / pronajímatel)`)
};

const en_clients_modules_ownership = /** @type {(inputs: Clients_Modules_OwnershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership (seller / landlord)`)
};

/**
* | output |
* | --- |
* | "Ownership (seller / landlord)" |
*
* @param {Clients_Modules_OwnershipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_modules_ownership = /** @type {((inputs?: Clients_Modules_OwnershipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Modules_OwnershipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_modules_ownership(inputs)
	return cs_clients_modules_ownership(inputs)
});